import React,{Component} from 'react';
import {connect} from "react-redux";
import {setUserInfo, setUserAccessTocken, setUserSignFlag} from "../../actions/AuthActions";
import _ from 'lodash';
import ApprovalService from "../../services/ApprovalService";
import {setFeatureFlag} from "../../actions/AppActions";
import LoggerService from "../../services/LoggerService";
import {ACTIVITY, ACTIVITY_CATEGORY} from "../../constants/LogConstants";

export class Header extends Component{

    constructor(props){
        super(props);
        this.state = {
            accessToken: '',
            userInfo:{}
        };

        this.parseURL = this.parseURL.bind(this);
        this.intiGlobalNav = this.intiGlobalNav.bind(this);
        this.loadGlobalNavAssets = this.loadGlobalNavAssets.bind(this);
        this.setAdobeID = this.setAdobeID.bind(this);
        this.setSusiInfo = this.setSusiInfo.bind(this);
        this.setProfile = this.setProfile.bind(this);
        this.getFeatureFlags = this.getFeatureFlags.bind(this);
        this.loadApp = this.loadApp.bind(this);
    }

    getFeatureFlags() {
        ApprovalService.loadFeatureFlag().then(response =>{
            const featureFlag = response.data;
            if(featureFlag.releases && (featureFlag.releases.length > 0) && (featureFlag.releases[0].features)){
                this.props.setFeatureFlag(featureFlag.releases[0].features);
                if(this.props.featureFlags && this.props.featureFlags.indexOf("ENABLE_UNIVERSAL_NAV") > -1){
                    this.loadApp();
                }
            }
            
        },
        function(error){   
           console.log("ERROR",error);
        });             
    }

    loadApp() {
        let self = this;
        window.fetchCSS = function () {
          const head = document.getElementsByTagName('head')[0];
          const css = document.createElement('link');
          css.rel = 'stylesheet';
          css.type = 'text/css';
          css.href =  self.props.applicationConfig.global_unav_css;
          css.async = false;
          head.appendChild(css);
        }

        window.fetchJS = function () {
          const body = document.getElementsByTagName('body')[0];
          const unavTarget = document.getElementById('unav-target');
          var js = document.createElement('script');
          js.src = self.props.applicationConfig.global_unav_js;
          body.appendChild(js);
          js.onload = function () {
            // decide what all universal nav elements to display
            const children = [
              {
                name: 'profile',
                attributes: {
                  isSignUpRequired: true,
                  messageEventListener: (event) => {
                    let {name, payload, executeDefaultAction} = event.detail;
                    if(name === 'System' && payload.subType === 'SignOut') {
                        executeDefaultAction();
                    }
                 }
                }
              }
            ];

            window.UniversalNav({
                target: unavTarget,
                env:self.props.applicationConfig.utilNavEnv,
                theme:'light',
                locale: self.props.adobeGlobalNavLocale || 'en_US', // change locale here
                children,
                accessToken: self.state.accessToken, // change here for accessToken
                imsClientId: self.props.applicationConfig.client_id, // change here for imsClientID
                userId: self.props.userInfo.userId, // change here for userId
                authId: self.props.userInfo.authId, // change here for authId
                email: '', // change here for email
                accountType: self.props.userInfo.account_type, // change accountType here
                analyticsContext: {
                    consumer: {
                    name: 'UniversalNavSampleApp',
                    version: '1.0',
                    platform: 'Web',
                    device: 'macOS',
                    os_version: 'Catalina', 
                    },
                    event: {
                        visitor_guid: ''
                    }
                }
                });
          };
        }

        window.fetchCSS();
        window.fetchJS();
    }

     parseURL() {
        let hashParams = decodeURIComponent(window.location.hash), params = {};
        if (hashParams) {
            hashParams.replace('#', '').replace('?', '&').replace('/', '=').split('&').forEach(function(pair) {
                let kv = pair.split('=');
                if (kv.length === 2) {
                    params[kv[0]] = kv[1];
                }
            });
            if (params.accessToken) {
                this.setState({accessToken:params.accessToken});
            }
        }
        if (window.utilityNavConfig) {
            // lib and css already loaded, so just create an instance
            this.intiGlobalNav();
        } else {
            this.loadGlobalNavAssets();
        }       
    }

    setProfile(profile) {
        if(profile && !_.isEmpty(profile)){
            const tokenDetails = window.adobeIMS.getAccessToken();
            this.props.setAccessTocken(tokenDetails.token);
            this.props.setUserDetails(profile);
            this.props.setSignFlag(true);
            const messageObject = {};
            messageObject.Message = "User logged in successfully";
            messageObject.Functionality = ACTIVITY.LOGIN;
            messageObject.ActivityCategory = ACTIVITY_CATEGORY.LOGIN;
            messageObject.Source_System = "IMS";
            messageObject.Flow = "Profile Set Success";
            messageObject.Screen = "CustomerApprovalPortal";
            messageObject.AgentId = "";
            messageObject.CustomerGuid = _.has(profile, "userId") ? profile.userId : (_.has(profile, "authId") ? profile.authId : "");
            messageObject.countryCode = _.has(profile, "countryCode") ? profile.countryCode : "";
            messageObject.Result = 'Success';
            LoggerService.saveSplunkLog(messageObject, 'info');
        }else{
            this.props.setAccessTocken('');
            this.props.setUserDetails({});
            this.props.setSignFlag(false);
            const messageObject = {};
            messageObject.Message = "User signed out / session ended";
            messageObject.Functionality = ACTIVITY.LOGOUT;
            messageObject.ActivityCategory = ACTIVITY_CATEGORY.LOGOUT;
            messageObject.Source_System = "IMS";
            messageObject.Flow = "Profile Cleared";
            messageObject.Screen = "CustomerApprovalPortal";
            messageObject.AgentId = "";
            messageObject.CustomerGuid = _.has(profile, "userId") ? profile.userId : (_.has(profile, "authId") ? profile.authId : "");
            messageObject.countryCode = _.has(profile, "countryCode") ? profile.countryCode : "";
            messageObject.Result = 'Success';
            LoggerService.saveSplunkLog(messageObject, 'info');
        }
       
    }

     loadGlobalNavAssets(){
        let self = this;
        let head = document.getElementsByTagName('head')[0];

        // load the AdobeGlobalNav css
        let css = document.createElement('link');
        css.rel = 'stylesheet';
        // css.href = this.props.applicationConfig.global_nav_css;
        css.href = this.props.applicationConfig.global_unav_css;
        head.appendChild(css);

        // load the AdobeGlobalNav js library
        let lib = document.createElement('script');
        lib.onload = function() {
            self.intiGlobalNav();
        };
        // lib.src = this.props.applicationConfig.global_nav_js;
        lib.src = this.props.applicationConfig.global_unav_js;
        head.appendChild(lib);
    }

    setSusiInfo(){
        window.drawerPageIMS = {
            data: {
                client_id: this.props.applicationConfig.client_id,
                response_type: "token",
                scope: this.props.applicationConfig.hendrix_scopes
            },
            idp_endpoint: this.props.applicationConfig.susi_url
        };
    }

    setAdobeID(){
        let self = this;
        window.adobeid = {
            uses_redirect_mode:true,
            client_id: window.drawerPageIMS.data.client_id,
            locale:this.props.adobeGlobalNavLocale,
            scope: window.drawerPageIMS.data.scope,
            useLocalStorage: false,
            environment: self.props.applicationConfig.imslib2Env,
            autoValidateToken: true,
            onReady: function(appState) {
                window.adobeIMS.getProfile().then((profile)=>{
                    if(window.adobeIMS.isSignedInUser()){
                        // var body = document.getElementsByTagName('body')[0];
                        // var utilNavParentDiv = document.getElementById('utilNavParent');  //DOM element within which UtilityNav should render
                        // window.utilityNavConfig.target = utilNavParentDiv;               // utilityNavConfig details are mentioned below in the wiki
                        // var utilityNavJs = document.createElement('script');
                        // utilityNavJs.src = self.props.applicationConfig.global_nav_js;
                        // body.appendChild(utilityNavJs);
                        // var utilityNavCss = document.createElement('link');
                        // utilityNavCss.rel = 'stylesheet';
                        // utilityNavCss.href = self.props.applicationConfig.global_nav_css;
                        // body.appendChild(utilityNavCss);
                        // utilityNavJs.onload = function () {
                        //     window.UtilityNav(window.utilityNavConfig);   // Renders UtilityNav in the target element, refer UtilityNav Structures and Sample Values for config values
                        // };
                        self.setProfile(profile);
                        self.getFeatureFlags();

                    }else{
                        if(window.adobeIMS){
                            self.setProfile({});
                            window.adobeIMS.signIn();
                        }else{
                            self.setProfile({});
                        }
                    }
                }).catch((error)=>{
                    if(window.adobeIMS){
                        self.setProfile({});
                        window.adobeIMS.signIn();
                    }else{
                        self.setProfile({});
                    }
                });
            }
        };
    }

    intiGlobalNav(){
        this.setSusiInfo();
        window.utilityNavConfig = {
            theme: 'dark',                                             // theme can take light or dark value. default value is light.
            env: this.props.applicationConfig.utilNavEnv,              // expected values will be stage or prod. default is stage.
            locale: this.props.adobeGlobalNavLocale,                   // expected value will be a valid locale from list given below in localization section. default is en_US
            analyticsContext:{                                         // Mandatory, This info is regarding target product integrating utilNav, which needs to be sent to ingest for analytics.
                consumer: {
                    name:this.props.applicationConfig.client_id,       // Name of the client Application
                    version:'1.0',                                     // Client application version
                    platform:'',                                       // Web/Desktop
                    client_id:this.props.applicationConfig.client_id,  // IMS client id
                    app_store_id:''                                    // in case of mobile app
                },
                event: {
                    visitor_guid: ''                                   // visitor_guid to be sent with ingest(analytics) event
                },
                consent: {                                             // Optional, This info is regarding consent library used by client.
                    name: 'Evidon',                                    // Name of library used to take consent
                    version: '0.0.0'                                   // Library Version
                }  
            },
            children: [
                { name: 'nav-profile' },
                { name: 'nav-icon'}
            ]
        };

        this.setAdobeID();

        //load IMS client lib
        let jstring = this.props.applicationConfig.imslib2+"?client_id=" + window.drawerPageIMS.data.client_id + "&locale=" + this.props.adobeGlobalNavLocale;
        let s = document.createElement('script');
        s.type='text/javascript';
        s.src=jstring;
        document.getElementsByTagName('body')[0].appendChild(s);
    }


    componentDidMount() {
        this.parseURL();

    }

    render(){
        return(
            <div className="navbar-header">
                <div className="navbar-brand project-title">
                    <img alt="Adobe" title="Adobe" src={process.env.PUBLIC_URL + '/adb-logo.png'} width="30px" className="adobe-logo"/>
                    <span>Approval Portal</span>
                </div>
                <div className="site-header-global-menu">
                    { 
                    this.props.featureFlags && this.props.featureFlags.indexOf("ENABLE_UNIVERSAL_NAV") > -1 ? <div id="unav-target"></div> : <div id="utilNavParent"></div>
                    }
                </div>
            </div>
          
        )
    }
}

const mapStateToProps = (state)=>{
    return{
        adobeGlobalNavLocale:state.LocaleReducer.adobeGlobalNavLocale,
        applicationConfig : state.AppReducer.applicationConfig,
        featureFlags: state.AppReducer.featureFlags,
        userInfo:state.AuthReducer.userInfo,
    }
};


const mapDispatchToProps = (dispatch)=>{
    return{
        setUserDetails:(tab)=>{dispatch(setUserInfo(tab))},
        setAccessTocken:(navs)=>{dispatch(setUserAccessTocken(navs))},
        setSignFlag:(status)=>{dispatch(setUserSignFlag(status))},
        setFeatureFlag:(list)=> {dispatch(setFeatureFlag(list))}
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(Header);
